import { Action } from 'redux';
import { isActionFactory } from '../isActionFactory';
import { OpenContentDetailDialog } from '../AppActionTypes';
import { IContentInfo } from '../../../ts/models/IContentInfo';

export interface OpenContentDetailDialogAction extends Action {
  content: IContentInfo;
}

export function openContentDetailDialog(content: IContentInfo): OpenContentDetailDialogAction {
  return {
    type: OpenContentDetailDialog,
    content
  };
}

export const isOpenContentDetailDialogAction = isActionFactory<OpenContentDetailDialogAction>(OpenContentDetailDialog);
